// @flow

/**
 * Getters related to subscription plans
 */
export default {
  // plans with null billing cycle expires (recurring)
  // exclude wallet
  subPlansRecurring(state: State): Array<SubscriptionPlan> {
    return Array.isArray(state.subscriptionPlans)
      ? state.subscriptionPlans.filter(
          (sp) => !sp.numBillingCycles && sp.vendorPlanId !== 'fbplus_wallet',
        )
      : []
  },

  // single plan purchases
  // exclude wallet
  subPlansSingle(state: State): Array<SubscriptionPlan> {
    return Array.isArray(state.subscriptionPlans)
      ? state.subscriptionPlans.filter(
          (sp) => sp.numBillingCycles && sp.vendorPlanId !== 'fbplus_wallet',
        )
      : []
  },
}
